(function () {
	"use strict";

	angular.module("angular.emlpayments")
    .factory("hvtRequestService", hvtRequestServiceFactory);

	hvtRequestServiceFactory.$inject = ["$q", "api", "notify", "appConfig"];

	function hvtRequestServiceFactory($q, api, notify, appConfig) {
		var selectedProgramTag,
        purchaserInformation,
        companyInformation,
        useOfCards,
        transactionInformation;

		return {
            addSelectedProgramTag,
            getCurrentSelectedProgramTag,
			addPurchaserInformation,
            getPurchaserInformation,
            addCompanyInformation,
            getCompanyInformation,
            addUseOfCards,
            getUseOfCards,
            addTransactionInformation,
            getTransactionInformation,
            submitHvtRequest,
            getHvtApprovalQueue,
            cancelHvtRequest,
            getHvtRequestDetails,
            beginFulfillment,
            insertHvtRequestCards,
            completeHvtRequestFulfillment,
            cancelHvtRequestFulfillment,
            getHvtFulfillmentHistory,
            getCurrencyByProgram,
            reset
		};

        function addSelectedProgramTag(programTag) {
            selectedProgramTag = programTag
        }

        function getCurrentSelectedProgramTag() {
            return selectedProgramTag;
        }

		function addPurchaserInformation(purchaserInfo) {
            purchaserInformation = purchaserInfo;
        }

        function getPurchaserInformation() {
            return purchaserInformation;
        }

        function addCompanyInformation(companyInfo) {
            companyInformation = companyInfo;
        }

        function getCompanyInformation() {
            return companyInformation;
        }

        function addUseOfCards(cardUse) {
            useOfCards = cardUse;
        }

        function getUseOfCards() {
            return useOfCards;
        }

        function addTransactionInformation(transactionInfo) {
            transactionInformation = transactionInfo;
        }

        function getTransactionInformation() {
            return transactionInformation;
        }

        function getCurrencyByProgram(programUniqueTag) {
            return api.hvt.getCurrencyByProgram(programUniqueTag);
        }

        function submitHvtRequest(programUniqueTag, purchaserInformation, companyInformation, useOfCards, transactionInformation, hvtRequestType, contactInformation) {
            return api.hvt.submitHvtRequest(
                appConfig.selectedMerchantGroup().uniqueTag, 
                programUniqueTag, 
                purchaserInformation, 
                companyInformation, 
                useOfCards, 
                transactionInformation, 
                hvtRequestType, 
                contactInformation
            );
        }

        function getHvtApprovalQueue(
        pageNumber = 1,
        pageSize = 10,
        sortAscending = true,
        sortColumn = 'hvtRequestId',
        searchValue = null,
        approvalDateBegin = null,
        approvalDateEnd = null) {
            return api.hvt.getApprovalQueue(
                appConfig.selectedMerchantGroup().uniqueTag,
                pageNumber,
                pageSize,
                sortAscending,
                sortColumn,
                searchValue, 
                approvalDateBegin, 
                approvalDateEnd
            );
        }

        function cancelHvtRequest(hvtRequestId, note) {
            return api.hvt.cancelHvtRequest(hvtRequestId, note);
        }

        function getHvtRequestDetails(hvtRequestId) {
            return api.hvt.getHvtRequestDetails(hvtRequestId);
        }

        function beginFulfillment(hvtRequestId, modifyWhileInProgress = false) {
            return modifyWhileInProgress ?
            api.hvt.overrideBeginHvtRequestFulfillment(hvtRequestId) :
            api.hvt.beginHvtRequestFulfillment(hvtRequestId);
        }

        function insertHvtRequestCards(hvtCards) {
            return api.hvt.insertHvtRequestCards(hvtCards);
        }

        function completeHvtRequestFulfillment(hvtRequestId) {
            return api.hvt.completeHvtRequestFulfillment(hvtRequestId);
        }

        function cancelHvtRequestFulfillment(hvtRequestId) {
            return api.hvt.cancelHvtRequestFulfillment(hvtRequestId);
        }

        function getHvtFulfillmentHistory(
            pageNumber = 0,
            pageSize = 10,
            searchValue = null,
            orderDateBegin = null,
            orderDateEnd = null,
            columnSort = 'DateFulfilled',
            sortAscending = false) {
            return api.hvt.getHvtFulfillmentHistory(
                appConfig.selectedMerchantGroup().uniqueTag,
                pageNumber,
                pageSize,
                searchValue,
                orderDateBegin,
                orderDateEnd,
                columnSort,
                sortAscending);
        }

        function reset() {
            selectedProgramTag = null;
            purchaserInformation = null;
            companyInformation = null;
            useOfCards = null;
            transactionInformation = null;
        }
	}
}());